module.exports = __webpack_public_path__ + "calculator_3.57db88ce862451f8d5c4b35ca79024e6.svg";